import SequenceViewer from './SequenceViewerV2.vue';
import { slotRender } from './slotRender';

SequenceViewer.slotRender = slotRender;

export default SequenceViewer;
